import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';

import CareersPage from '../components/company/careers-page';

const CareersRoute = ({ careersData }) => (
  <Fragment>
    <DocumentTitle title="Careers | NerdWallet" />
    <CareersPage careersData={careersData} />
  </Fragment>
);

CareersRoute.displayName = 'CareersRoute';
CareersRoute.analyticsName = 'careers_page';

CareersRoute.propTypes = {
  careersData: PropTypes.object.isRequired,
};

export default connect(({ careersData }) => ({ careersData }))(CareersRoute);
